import React from "react";

export const UiSliderImageCard = (props) => {
    return (
        <>
            <div className="sb-top-slider-img-card-wr">
                {props.content && (
                    <div
                        className={
                            props.contentTopLeftAlign
                                ? "sb-top-slider-img-card-wr__content sb-top-left"
                                : "sb-top-slider-img-card-wr__content"
                        }
                    >
                        <div className="sb-top-slider-img-card-wr__content__gradient"></div>
                        <div>
                            <h2>{props.contentTitle}</h2>
                            <p>{props.contentDedsc}</p>
                        </div>
                    </div>
                )}
                {props.video ? (
                    <video
                        width={"100%"}
                        height={"350"}
                        playsInline
                        controls
                        loop
                        muted
                        autoPlay
                    >
                        <source src={props.video} type="video/mp4" />
                    </video>
                ) : (
                    <img
                        src={props.image}
                        className={
                            props.content &&
                            "sb-top-slider-img-card-wr__content_img"
                        }
                    />
                )}

                <div className="sb-top-slider-img-card-wr__gradient"></div>
            </div>
        </>
    );
};
